module.exports = __webpack_public_path__ + "media/images/Workplace-186a0330.svg";